import $ from 'jquery'

export class SiteSwitcher {
    constructor() {
        this.$toggles = $('[data-js-site-switcher] .header-site-switcher-toggle')

        if (!this.$toggles.length) return

        this.classes = {
            expanded: 'is-open',
        }

        this.bindEvents()
    }

    bindEvents() {
        this.$toggles.on('click', this.handleToggle.bind(this))
        $(document).on('click', this.handleOutsideClick.bind(this))
        $(document).on('keydown', this.handleKeydown.bind(this))
    }

    /**
     * @param {Event} e
     */
    handleToggle(e) {
        const $toggle = $(e.currentTarget)
        const $switcher = $toggle.closest('[data-js-site-switcher]')
        const isExpanded = $toggle.attr('aria-expanded') === 'true'

        this.closeAll()

        if (!isExpanded) {
            $toggle.attr('aria-expanded', 'true')
            $switcher.find('.header-site-switcher-dropdown').attr('aria-hidden', 'false')
            $switcher.addClass(this.classes.expanded)
        }
    }

    /**
     * @param {Event} e
     */
    handleOutsideClick(e) {
        if (!$(e.target).closest('[data-js-site-switcher]').length) {
            this.closeAll()
        }
    }

    /**
     * @param {KeyboardEvent} e
     */
    handleKeydown(e) {
        if (e.key === 'Escape') {
            this.closeAll()
        }
    }

    closeAll() {
        $('[data-js-site-switcher]').each((_, el) => {
            const $switcher = $(el)
            $switcher.find('.header-site-switcher-toggle').attr('aria-expanded', 'false')
            $switcher.find('.header-site-switcher-dropdown').attr('aria-hidden', 'true')
            $switcher.removeClass(this.classes.expanded)
        })
    }
}
